module.exports = __webpack_public_path__ + "static/img/test_top.6b5eed7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/test/test_top.png
// module id = wCJN
// module chunks = 1